export const dictionary = {
	de: {
		saved: {
			title: 'Speichern',
			message: 'Das Element wurde erfolgreich gespeichert!',
		},
		archived: {
			title: 'Löschen',
			message: 'Das Element wurde erfolgreich gelöscht!',
		},
		error: 'Fehler',
	},
	rules: {
		required: (v) => {
			console.log('test übersetzung mit parameter', v);
			return `Eingabe für ${v.values} erforderlich.`;
		},
	},
};
